// extracted by mini-css-extract-plugin
module.exports = {"tree-menu-container":"_2ko8z","treeMenuContainer":"_2ko8z","section-title":"_24S1Z","sectionTitle":"_24S1Z"};